var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHaidiAddIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#haidiAddIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#6FA9FF",
  d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8Zm4 8.5a.5.5 0 0 1-.5.5H9v2.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V9H4.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H7V4.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V7h2.5a.5.5 0 0 1 .5.5v1Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "haidiAddIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgHaidiAddIcon;